/**
 * CO2 단위 변환 유틸리티 함수
 * raw 데이터가 ppm 기준일 때 다른 단위로 변환
 */

/**
 * CO2 ppm 값을 % 단위로 변환
 * @param ppmValue - ppm 단위의 CO2 값
 * @returns % 단위로 변환된 값 (소수점 3자리)
 */
export const convertCO2PpmToPercent = (ppmValue: number): number => {
  if (typeof ppmValue !== 'number' || isNaN(ppmValue)) {
    return 0;
  }
  // ppm을 %로 변환: 1% = 10,000 ppm
  const result = ppmValue / 10000;
  // 소수점 3자리로 반올림
  return Math.round(result * 1000) / 1000;
};

/**
 * CO2 ppm 값을 mg/m³ 단위로 변환 (25℃ 기준)
 * @param ppmValue - ppm 단위의 CO2 값
 * @returns mg/m³ 단위로 변환된 값 (소수점 1자리)
 */
export const convertCO2PpmToMgPerCubicMeter = (ppmValue: number): number => {
  if (typeof ppmValue !== 'number' || isNaN(ppmValue)) {
    return 0;
  }
  // 25℃ 기준 ppm → mg/m³ 변환: ppm * 1.8
  const result = ppmValue * 1.8;
  // 소수점 1자리로 반올림
  return Math.round(result * 10) / 10;
};
